import { Outlet } from 'react-router-dom';
import TopBar from '../Components/TopBar.jsx'
import * as React from 'react';

function OnlyTopBar() {
  return <React.Fragment>
    <TopBar />
    <Outlet />
  </React.Fragment>
}

export default OnlyTopBar